import {
  XIcon_default
} from "./chunk-6Z4AEZQN.mjs";
export {
  XIcon_default as default
};
